export default __webpack_public_path__ + "static/media/shopify-section-3.773a48d8.png";